import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
var CategorySelectionDialogComponent = (function () {
    function CategorySelectionDialogComponent(dialogRef, data, translate) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.translate = translate;
        this.categories = data.categories;
        this.kidsModule = data.kidsModule;
    }
    CategorySelectionDialogComponent.prototype.ngOnInit = function () { };
    CategorySelectionDialogComponent.prototype.choose = function (category) {
        this.dialogRef.close(category);
    };
    return CategorySelectionDialogComponent;
}());
export { CategorySelectionDialogComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/category-selection-dialog/category-selection-dialog.component.ts.pre-build-optimizer.js